import { cn } from '@/lib/utils';
import SectionCard from '@/components/ui/SectionCard.tsx';
import {
  BillRowVm,
  BillSectionVm,
} from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import MoneyAmountList from '@/features/dashboard/bookingChanges/components/primitives/MoneyAmountList.tsx';
import BillSectionPanel from './BillSectionPanel';
import { pluralizeItems } from '@/features/dashboard/bookingChanges/utils/plurals.ts';

interface BillSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  section: BillSectionVm;
  isEditing: boolean;
  isOpen: boolean;
  onToggle: () => void;
  onRowAction?: (row: BillRowVm) => void;
  onAddManualRow?: () => void;
}

/**
 * Sekcja rachunku — wspólna zwijana karta wypełniona siatką wierszy.
 *
 * Sumę pokazujemy dla sekcji z więcej niż jedną pozycją, liczoną przed filtrem
 * „Tylko zmienione”, żeby nie znikała przy jego włączeniu.
 */
const BillSection = ({
  section,
  isEditing,
  isOpen,
  onToggle,
  onRowAction,
  onAddManualRow,
  className,
  ...props
}: BillSectionProps) => {
  const rowCount = section.rows.length;
  // Pusta lista kwot znaczy „sekcja bez pieniędzy” — wtedy podsumowania nie ma
  // wcale, zamiast zera w walucie wybranej na chybił trafił.
  const showSum =
    section.sum.length > 0 &&
    ((section.totalRowCount ?? rowCount) > 1 || !isOpen);

  return (
    <SectionCard
      title={section.title}
      hint={isOpen ? section.hint : pluralizeItems(rowCount)}
      summary={showSum ? <MoneyAmountList values={section.sum} /> : undefined}
      isOpen={isOpen}
      onToggle={onToggle}
      className={cn(className)}
      {...props}
    >
      <BillSectionPanel
        section={section}
        isEditing={isEditing}
        onRowAction={onRowAction}
        onAddManualRow={onAddManualRow}
      />
    </SectionCard>
  );
};

export default BillSection;
